import { connect } from 'react-redux';
import PracticeSheetView from './PracticeSheetView';
import SubscriptionCheck from '../../../components/SubscriptionCheck';
import { getLessonPropswithSlug, getNextUrl } from '../../lesson/components/lesson-utils';
import {
  updateCourseProgress,
  updateLessonCompletedProgress,
  updatePathProgress,
  updateLessonProgress,
  getLessonsProgress,
} from '../../../actions/my-progress';
import { setFavorite, unsetFavorite } from '../../../actions/favorites';

const mapState = (
  { collections, courses, favorites, practice, paths, courses: newCourses, myPath, myProgress },
  { match },
) => {
  const { watching } = courses || {};
  const { currentCourse } = watching || {};
  const { slug: courseSlug } = currentCourse || '';
  const { url, params } = match;
  const { collectionSlug, practiceSlug } = params;
  const { level } = myProgress || {};
  const { collection } = collections || {};
  const { watching: pathsWatching } = paths;
  const { watching: coursesWatching } = newCourses;
  const { slugs: practiceSlugs, error, watching: practiceWatching } = practice;
  const lessonProps = getLessonPropswithSlug(
    practiceSlug,
    pathsWatching,
    coursesWatching,
    practiceWatching,
  );
  const nextURL = getNextUrl(url, lessonProps);
  const { nextCourse } = lessonProps;
  let { nextLesson } = lessonProps;
  let upNextTitle = nextLesson?.title || null;
  if (nextLesson === null && nextCourse) {
    const { lessons } = nextCourse;
    nextLesson = lessons[0] || null;
    upNextTitle = (nextLesson || {}).title || null;
  }
  const currentPractice = practiceSlugs[practiceSlug] || null;
  const currentPracticeProgress = myProgress?.lessons?.[currentPractice?.id];
  const currentPracticeCompleted = currentPracticeProgress?.completed || false;
  const favoritesKeys = favorites.keys || {};
  return {
    url,
    collectionSlug,
    collection,
    practiceSlug,
    courseSlug,
    currentPractice,
    currentPracticeCompleted,
    error,
    upNextTitle,
    myPath,
    level,
    nextLesson,
    pathsWatching,
    coursesWatching,
    practiceWatching,
    nextURL,
    favoritesKeys,
  };
};

const mapDispatch = {
  getLessonsProgress,
  updateCourseProgress,
  updateLessonCompletedProgress,
  updateLessonProgress,
  updatePathProgress,
  setFavorite,
  unsetFavorite,
};

export default SubscriptionCheck(connect(mapState, mapDispatch)(PracticeSheetView));
